const radialbardata = [
    {
        "id": "Supermarket",
        "data": [
            {
                "x": "Vegetables",
                "y": 22
            },
            {
                "x": "Fruits",
                "y": 24
            },
            {
                "x": "Meat",
                "y": 45
            },
            {
                "x": "Fish",
                "y": 291
            }
        ]
    },
    {
        "id": "Combini",
        "data": [
            {
                "x": "Vegetables",
                "y": 25
            },
            {
                "x": "Fruits",
                "y": 255
            },
            {
                "x": "Meat",
                "y": 203
            },
            {
                "x": "Fish",
                "y": 42
            }
        ]
    },
    {
        "id": "Online",
        "data": [
            {
                "x": "Vegetables",
                "y": 155
            },
            {
                "x": "Fruits",
                "y": 162
            },
            {
                "x": "Meat",
                "y": 84
            },
            {
                "x": "Fish",
                "y": 237
            }
        ]
    }
]
export default radialbardata;